define(function(require) {
	const IpsModel = require('civicsBase/ipsModel');
	return IpsModel.extend({
		urlRoot:'/delegate/civics-api/api/cashiering/sendemail',
		url: function(){
			var url = this.urlRoot;
			var parameters = '';
			if (this.urlParameters != undefined) {
				parameters = builder.buildUrlParameters(this.urlParameters)
			}

			if (this.get('transactionToken') && this.get('transactionToken').length > 1) {
				var transactionToken = this.get('transactionToken');
				if (parameters.indexOf('?') >= 0) {
					parameters += '&TransactionToken='+this.encodeComponent(transactionToken);
				} else {
					parameters += '?TransactionToken='+this.encodeComponent(transactionToken);
				}

				if(this.get('paymentTransactionKey')){
					var paymentTransactionKey = this.get('paymentTransactionKey');
					if (parameters.indexOf('?') >= 0) {
						parameters += '&PaymentTransactionKey='+ paymentTransactionKey;
					} else {
						parameters += '?PaymentTransactionKey='+ paymentTransactionKey;
					}
				}
				url += '/'+parameters;
			}

			return url;
		}
	});
});
